"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionEntry = void 0;
const Entry = __importStar(require("root/src/client/web/giveaway/components/Entry"));
const ButtonNew_1 = __importDefault(require("root/src/client/web/base/ButtonNew"));
const LoadingCircles_1 = __importDefault(require("root/src/client/web/base/LoadingCircles"));
const useActionEntry_1 = require("root/src/client/web/giveaway/features/GiveawayStats/hooks/useActionEntry");
const BaseTooltip_1 = require("root/src/client/web/base/BaseTooltip/BaseTooltip");
const commonStyles_1 = require("root/src/client/web/commonStyles");
const Typography_1 = require("root/src/client/web/typography/Typography");
const useUser_1 = require("root/src/client/logic/userData/hooks/useUser");
const useCreatorGiveaways_1 = require("root/src/client/web/giveaway/hooks/useCreatorGiveaways");
const EntryDisabledTooltipContent = () => {
    const isAuthenticated = (0, useUser_1.useIsAuthenticated)();
    const giveaway = (0, useCreatorGiveaways_1.useCreatorActiveGiveaway)();
    if (!isAuthenticated) {
        return (<BaseTooltip_1.BaseTooltipContent>
				You cannot submit this entry<br />
				Please log in.
			</BaseTooltip_1.BaseTooltipContent>);
    }
    if (!(giveaway === null || giveaway === void 0 ? void 0 : giveaway.isSteamEntered)) {
        return (<BaseTooltip_1.BaseTooltipContent>
				You cannot submit this entry<br />
				Please connect your Steam account.
			</BaseTooltip_1.BaseTooltipContent>);
    }
    if (!(giveaway === null || giveaway === void 0 ? void 0 : giveaway.isEntered)) {
        return (<BaseTooltip_1.BaseTooltipContent>
				You cannot submit this entry<br />
				Please enter to the giveaway.
			</BaseTooltip_1.BaseTooltipContent>);
    }
    return null;
};
const ActionEntry = (props) => {
    var _a, _b;
    const { entry, disabled } = props;
    const { onEntrySubmit, isLoading } = (0, useActionEntry_1.useActionEntry)(entry);
    return (<Entry.Root>
			<Entry.Label className="gap-4">
				<Entry.LabelIcon src={((_a = entry.icon) === null || _a === void 0 ? void 0 : _a.src) || ''} alt={entry.label}/>
				<Entry.LabelText>{entry.label}</Entry.LabelText>
			</Entry.Label>
			<Entry.Trigger>
				{entry.isDone ? <Entry.SuccessIcon /> : (<>
						<BaseTooltip_1.BaseTooltip tooltip={disabled && <EntryDisabledTooltipContent />}>
							<ButtonNew_1.default style={{ background: commonStyles_1.colorsNew.white, borderRadius: '100px', height: 40, width: 120 }} disabled={disabled} onClick={onEntrySubmit} typography={Typography_1.typographyVariants.providerSignIn}>
								<Entry.ButtonContent>
									<Entry.ButtonIcon src={((_b = entry.icon) === null || _b === void 0 ? void 0 : _b.src) || ''} alt={entry.label}/>
									<Entry.ButtonAction>{entry.actionName}</Entry.ButtonAction>
								</Entry.ButtonContent>
							</ButtonNew_1.default>
						</BaseTooltip_1.BaseTooltip>
						<Entry.Score>{isLoading ? <LoadingCircles_1.default width={20} height={20}/> : `+${entry.score}`}</Entry.Score>
					</>)}
			</Entry.Trigger>
		</Entry.Root>);
};
exports.ActionEntry = ActionEntry;
